const OneCommentaire = ({ comment }) => {
  const initials = comment.pseudo
    ? comment.pseudo.trim().slice(0, 2).toUpperCase()
    : "??";

  return (
    <li
      key={comment._id}
      className="group relative flex w-full flex-col gap-4 overflow-hidden rounded-lg border border-gray-700 bg-[#1f2d32] p-4 shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:border-[#c792cf]/70 hover:shadow-[0_0_18px_rgba(199,146,207,0.12)]"
    >
      <span className="absolute left-0 top-0 h-full w-1 bg-[#c792cf] opacity-70 transition-opacity group-hover:opacity-100" />
      <div className="flex items-center gap-3 pl-2">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#c792cf]/70 bg-[#2b3e45] text-sm font-bold text-[#c792cf]">
          {initials}
        </span>
        <div className="min-w-0 flex-1">
          <span className="block truncate text-lg font-bold text-[#c792cf]">
            {comment.pseudo}
          </span>
          <span className="block truncate text-xs capitalize text-gray-400">
          {comment._createdAt ? new Date(comment._createdAt).toLocaleString("fr-fr", {
            weekday: "long",
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "numeric",
          }) : comment._createdAtLocal}
          </span>
        </div>
      </div>
      <p className="border-l border-[#c792cf]/40 pl-3 text-base leading-relaxed text-gray-200">
        {comment.commentaire}
      </p>
    </li>
  );
};

export default OneCommentaire;